export const makeCancelable = (promise) => {
    let hasCanceled_ = false;

    const wrappedPromise = new Promise((resolve, reject) => {
        // console.log("makeCancelable: start wrappedPromise")
        promise.then((val) =>
            hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
        );
        promise.catch((error) =>
            hasCanceled_ ? reject({isCanceled: true}) : reject({error})
        );
    });

    return {
        promise: wrappedPromise,
        cancel() {
            hasCanceled_ = true;
        },
    };
};

export const makeCancelableAsync = (callback) => {
    let hasCanceled_ = false;
    // noinspection ExceptionCaughtLocallyJS
    const runAsyncFunc = async (...args) => {
        try {
            // console.log("makeCancelableAsync: args", args)
            const result = await callback.apply(null, args)
            if (hasCanceled_) {
                // eslint-disable-next-line no-throw-literal
                throw {isCanceled: true}
            }
            return result
        } catch (error) {
            // if (process.env.NODE_ENV === "development") {
            //     console.log("makeCancelableAsync catch: hasCanceled_", hasCanceled_, "error", error)
            // }
            if (hasCanceled_) {
                // eslint-disable-next-line no-throw-literal
                throw {isCanceled: true}
            }
            // eslint-disable-next-line no-throw-literal
            throw {error}
        }
    }

    return {
        runAsyncFunc: runAsyncFunc,
        cancel: () => {
            hasCanceled_ = true;
            // console.log("makeCancelableAsync cancel", hasCanceled_)
        },
    };
};